<template>
  <div class="chart-container d-flex flex-column justify-content-center align-items-center"
       style="height: 300px; width: 100%;">
    <span>Mean: {{mean && mean.toFixed(2)}}</span>
    <HorizontalBarChart style="margin: 10px; height: 250px; width: 100%;" :options="options"
                        :chartData="data"></HorizontalBarChart>
  </div>
</template>

<script>
import HorizontalBarChart from './HorizontalBarChart'
import tooltips from '../../constants/tooltips'

export default {
  name: 'HorizontalAnalyticsChart',
  components: { HorizontalBarChart },
  props: {
    data: Object,
    max: {
      type: Number,
      required: false
    },
    mean: {
      type: Number,
      required: false
    },
    nValues: Array
  },
  data () {
    return {
      options: {
        scales: {
          xAxes: [{
            gridLines: {
              display: true
            },
            ticks: {
              beginAtZero: true,
              min: 0,
              max: this.max
            }
          }],
          yAxes: [{
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          labels: {
            defaultFontFamily: '\'Open Sans\', sans-serif'
          }
        },
        tooltips: {
          enabled: false,
          custom: function (tooltipModel) {
            // Tooltip Element
            let tooltipEl = document.getElementById('chartjs-tooltip')

            // Create element on first render
            if (!tooltipEl) {
              tooltipEl = document.createElement('div')
              tooltipEl.id = 'chartjs-tooltip'
              tooltipEl.innerHTML = '<table></table>'
              document.body.appendChild(tooltipEl)
            }

            // Hide if no tooltip
            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = 0
              return
            }

            // Set caret Position
            tooltipEl.classList.remove('above', 'below', 'no-transform')
            if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign)
            } else {
              tooltipEl.classList.add('no-transform')
            }

            function getBody (bodyItem) {
              return bodyItem.lines
            }

            // Set Text
            if (tooltipModel.body) {
              let titleLines = tooltipModel.title || []
              let bodyLines = tooltipModel.body.map(getBody)

              let innerHtml = '<div class="d-flex flex-column">'

              titleLines.forEach(function (title) {
                innerHtml += '<span><b>' + title + '</b></span>'
              })
              innerHtml += '</div><div class="d-flex flex-column">'

              bodyLines[0].forEach(function (body, i) {
                innerHtml += '<span>' + body + '</span>'
              })
              innerHtml += '</div>'

              let tableRoot = tooltipEl.querySelector('table')
              tableRoot.innerHTML = innerHtml
            }

            // `this` will be the overall tooltip
            let position = this._chart.canvas.getBoundingClientRect()

            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1
            tooltipEl.style.backgroundColor = 'rgba(0,0,0,0.73)'
            tooltipEl.style.color = 'white'
            tooltipEl.style.position = 'absolute'
            const caretPosition = tooltipModel.caretX > position.left ? position.left + window.pageXOffset + tooltipModel.caretX - 160 : position.left + window.pageXOffset + tooltipModel.caretX
            tooltipEl.style.left = `${caretPosition}px`
            tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px'
            tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
            tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
            tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
            tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px'
            tooltipEl.style.pointerEvents = 'none'
          },
          callbacks: {
            label: (tooltipItem, data) => {
              const dataType = data.datasets[0].label
              const value = tooltipItem.xLabel.toFixed(2)
              const aggregationType = tooltipItem.label.replace(/ /g, '_').toLowerCase()
              const nCountValue = this.nValues && this.nValues.length ? this.nValues.find(el =>
                tooltipItem.label === 'Neutral'
                  ? el.key.includes('just_right')
                  : el.key.includes(aggregationType)
              ).value : 0
              const nCount = `n = ${nCountValue}`
              const score = `Score = ${value}%`
              const tooltipKey = ['Strength', 'Liking', 'Purchase intent'].includes(dataType) ? dataType.replace(/ /g, '_').toLowerCase() : 'attribute'
              const tooltipData = tooltips[`chart_${tooltipKey}`].find(el => el.key === aggregationType)
              return [score, nCount, tooltipData.text]
            }
          }
        },
        barValueSpacing: 20,
        responsive: true,
        maintainAspectRatio: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.chart-container {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
}
</style>
